import { UserDetail, UserEventList, UserList, type UserEventQuery, type UserQuery } from '@regigov/contracts';
import { api } from './client';

const qs = (query: Record<string, string | number | undefined>) => new URLSearchParams(Object.entries(query).filter((e): e is [string, string | number] => e[1] !== undefined && e[1] !== '').map(([k, v]) => [k, String(v)]));

/** CER user administration (`users:admin`, docs/user-admin.md). */
export const userAdminApi = {
  list: (query: UserQuery) => api(`/users?${qs(query)}`, UserList),
  get: (id: string) => api(`/users/${id}`, UserDetail),
  events: (id: string, query: UserEventQuery) => api(`/users/${id}/events?${qs(query)}`, UserEventList),
};
